/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import * as React from 'react';

import Notification from './components/Notification';
import {NotificationWithVisibility} from './model';
import {RootStateWithNotifications} from './reducers';
import {notificationActionButtonClicked, notificationHidden} from './actions';
import {useDispatch, useSelector} from 'react-redux';
import {Container} from 'react-bootstrap';
import styles from './styles';
import {css} from 'aphrodite/no-important';

const Notifications = (): JSX.Element => {
	const notifications =
		useSelector<RootStateWithNotifications, NotificationWithVisibility[]>(state => state.notifications.notifications);

	const dispatch = useDispatch();
	const handleNotificationActionButtonClick = (identifier: string) => dispatch(notificationActionButtonClicked({identifier}));
	const handleDismissNotification = (identifier: string) => dispatch(notificationHidden({identifier}));

	return <Container fluid={true} className={css(styles.notificationsGrid)}>
		{
			notifications.map((notification: NotificationWithVisibility) => (
				<Notification
					actionButtonText={notification.entry.actionButtonText}
					key={notification.entry.identifier}
					hidden={notification.hidden}
					level={notification.entry.level}
					onActionButtonClick={() => handleNotificationActionButtonClick(notification.entry.identifier)}
					onDismiss={() => handleDismissNotification(notification.entry.identifier)}
					text={notification.entry.text}
					textAfterActionButton={notification.entry.textAfterActionButton}/>
			))
		}
	</Container>;
};

export default Notifications;
